import { BridgeWarAvatars, bridgeWarAvatars } from './avatars';
import { BridgeWarBackgrounds, bridgeWarBackgrounds } from './backgrounds';
import { BridgeWarIcons, bridgeWarIcons } from './icons';
import { BridgeWarLogos, bridgeWarLogos } from './wars-logos';
import bridgeWarAssetsConfig, { BridgeWarAssetsConfig } from './config';

type BridgeWarAssets = {
    avatars: BridgeWarAvatars;
    backgrounds: BridgeWarBackgrounds;
    config: BridgeWarAssetsConfig;
    icons: BridgeWarIcons;
    logos: BridgeWarLogos;
};

export const bridgeWarAssets: BridgeWarAssets = {
    avatars: bridgeWarAvatars,
    backgrounds: bridgeWarBackgrounds,
    config: bridgeWarAssetsConfig,
    icons: bridgeWarIcons,
    logos: bridgeWarLogos,
};
